import { ConfigDataInterface } from './ConfigApiInterface';
import { Config_LegalPerson_PageMenu_ApiEnum } from './LegalPersonDetailConfigApiInterface';
import { Config_Person_PageMenu_ApiEnum } from './PersonDetailConfigApiInterface';

export enum Config_AgentsInsurancesSearch_ActionsMenu_ApiEnum {
    'create_agent_insurance' = 'create_agent_insurance',
}

export enum Config_AgentsInsurancesSearch_Modules_ApiEnum {
    'results' = 'results',
    'overview' = 'overview',
    'indications' = 'indications',
}

export enum Config_AgentsInsurancesSearch_ActionsOther_ApiEnum {
    'NOTHING' = 'NOTHING',
}

export enum Config_AgentsInsurancesSearch_PageSubMenu_ApiEnum {
    'NOTHING' = 'NOTHING',
}

export interface Config_AgentsInsurancesSearch_ApiInterface
    extends ConfigDataInterface<
        Config_AgentsInsurancesSearch_Modules_ApiEnum,
        Config_AgentsInsurancesSearch_ActionsMenu_ApiEnum,
        Config_AgentsInsurancesSearch_ActionsOther_ApiEnum,
        Config_LegalPerson_PageMenu_ApiEnum | Config_Person_PageMenu_ApiEnum,
        Config_AgentsInsurancesSearch_PageSubMenu_ApiEnum
    > {
    _?: boolean;
}
